import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Activiteit} from '../activiteit';
import {Client} from '../../client/client';
import {Zone} from '../../zone/zone';
import User from '../../core/auth/user';

@Component({
    selector: 'zah-activiteit-card',
    templateUrl: './activiteit-card.component.html',
    styleUrls: ['./activiteit-card.component.scss'],
    standalone: false
})
export class ActiviteitCardComponent {

  @Input()
  activiteit: Activiteit;
  @Input()
  client: Client;
  @Input()
  auteur: User;
  @Input()
  zones: Array<Zone>;
  @Output()
  verwerkClicked: EventEmitter<Activiteit> = new EventEmitter<Activiteit>();
  @Output()
  activiteitCardClicked: EventEmitter<Activiteit> = new EventEmitter<Activiteit>();

  getZoneIdsToDisplay() {
    const activiteitZoneId = this.activiteit.getClientZone();
    return activiteitZoneId ? [activiteitZoneId] : this.client.getUniqueZoneIds();
  }

  onVerwerkClicked(): void {
    this.verwerkClicked.emit(this.activiteit);
  }

  onActiviteitCardClick(): void {
    this.activiteitCardClicked.emit(this.activiteit);
  }
}
